import { P } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { Group, Path, Segment } from "paper";
export class Cuboid {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 6, maxX: 600,
                minY: 8, maxY: 600,
                toAppearance: (f, p) => f({
                    height: p.y,
                    width: p.x
                }),
                fromAppearance: a => P(a.width, a.height),
                scale: 2.0,
            }
        ];
    }
    /**
            P6               P5
            +----------------+
            |                |
      P3+---+-----------+P2  |
        |               |    |
        |               |    |
        |               +----+ P4
        |               |
        |               |
        +---------------+
      PO                 P1

     */
    render(appearance) {
        const { width, height, depth } = appearance;
        const depthVector = P(depth, -depth / 2);
        const p3 = P(0, 0);
        const p0 = P(0, height);
        const p1 = P(width, height);
        const p2 = P(width, 0);
        const p6 = p3.add(depthVector);
        const p5 = p2.add(depthVector);
        const p4 = p1.add(depthVector);
        const frontWall = new Path([
            new Segment(p0),
            new Segment(p1),
            new Segment(p2),
            new Segment(p3),
        ]).close();
        const topWall = new Path([
            new Segment(p3),
            new Segment(p2),
            new Segment(p5),
            new Segment(p6),
        ]).close();
        const sideWall = new Path([
            new Segment(p1),
            new Segment(p4),
            new Segment(p5),
            new Segment(p2),
        ]).close();
        const graphic = new Group([frontWall, topWall, sideWall]);
        BasicShapes.applyCustom(appearance, (fill) => {
            frontWall.fillColor = fill;
            topWall.fillColor = fill.color().ladd(5).string();
            sideWall.fillColor = fill.color().ladd(-5).string();
        }, (width, stroke) => {
            const outline = new Path([p0, p1, p4, p5, p6, p3].map(p => new Segment(p)))
                .close()
                .withStroke(width, stroke);
            graphic.addChild(outline);
        });
        return {
            graphic: graphic,
            hitShape: graphic.rectHitShape(),
            pivot: P(width / 2, height / 2)
        };
    }
}
Cuboid.properties = {
    label: "Cuboid",
    flippable: true,
    defaultAppearance: Object.assign(Object.assign({}, BasicShapes.defaultAppearance), { width: 120, height: 100, depth: 50 }),
    appearanceSpecs: [
        ...BasicShapes.specs,
        BasicShapes.header,
        {
            spec: "slider", key: "depth", label: "Depth",
            min: 0, max: 200
        }
    ],
};
